<template>
  <div class="param px" :class="{ cn: isCN }">
    <div class="title" v-if="false">
      {{ $t("mouse.paramSettings") }}
    </div>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.keySensitivity") }}</div>
      {{ $t("slow") }}
      <a-slider
        class="slider"
        v-model="keySensitivity"
        :min="10"
        :max="1"
        :reverse="true"
        :dots="true"
        :marks="{ 1: '', 7: '', 15: '', 31: '', 47: '', 63: '', 80: '' }"
        :step="null"
        :tooltipVisible="false"
        style="margin-left: 0.3rem;"
      />
      {{ $t("fast") }}
      <div class="tip" style="margin-left: 0.3rem;">
        {{ $t("mouse.keySensitivityTip") }}
      </div>
    </div>
    <div class="tip" style="color: #fff;">
      {{ $t("mouse.debounceTip") }}
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.USBDebounce") }}</div>
      {{ $t("slow") }}
      <a-slider
        class="slider"
        v-model="USBDebounce"
        :min="0"
        :max="6"
        :tooltipVisible="false"
        style="margin-left: 0.3rem;"
      />
      {{ $t("fast") }}
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.twoPointFourGDebounce") }}</div>
      {{ $t("slow") }}
      <a-slider
        class="slider"
        v-model="twoPointFourGDebounce"
        :min="0"
        :max="6"
        :tooltipVisible="false"
        style="margin-left: 0.3rem;"
      />
      {{ $t("fast") }}
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.BTDebounce") }}</div>
      {{ $t("slow") }}
      <a-slider
        class="slider"
        v-model="BTDebounce"
        :min="0"
        :max="6"
        :tooltipVisible="false"
        style="margin-left: 0.3rem;"
      />
      {{ $t("fast") }}
    </div>

    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.buttonChangeTime") }}</div>
      <a-slider
        class="slider"
        v-model="buttonChangeTime"
        :min="1"
        :max="255"
        :tooltipVisible="false"
      />
      <md-field class="num">
        <md-input
          @change="buttonChangeTime = Number($event.target.value)"
          :value="buttonChangeTime"
          class="number-input"
          min="1"
          max="255"
          step="1"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 255 ? 255 : this.value;
          this.value = this.value < 1 ? 1 : this.value;"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <div class="tip" v-html="$t('mouse.buttonChangeTimeTip')"></div>
    </div>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.wheelToButton") }}</div>
      <a-slider
        class="slider"
        v-model="wheelToButton"
        :min="1"
        :max="255"
        :tooltipVisible="false"
      />
      <md-field class="num">
        <md-input
          @change="wheelToButton = Number($event.target.value)"
          :value="wheelToButton"
          class="number-input"
          min="1"
          max="255"
          step="1"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 255 ? 255 : this.value;
          this.value = this.value < 1 ? 1 : this.value;"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <div class="tip" v-html="$t('mouse.wheelToButtonTip')"></div>
    </div>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.buttonToWheel") }}</div>
      <a-slider
        class="slider"
        v-model="buttonToWheel"
        :min="1"
        :max="255"
        :tooltipVisible="false"
      />
      <md-field class="num">
        <md-input
          @change="buttonToWheel = Number($event.target.value)"
          :value="buttonToWheel"
          class="number-input"
          min="1"
          max="255"
          step="1"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 255 ? 255 : this.value;
          this.value = this.value < 1 ? 1 : this.value;"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <div class="tip" v-html="$t('mouse.buttonToWheelTip')"></div>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.sleepOneTimeBT") }}</div>
      <a-radio-group v-model="sleepOneTimeBT" class="radio-group">
        <a-radio class="radio" :value="15"> 15s </a-radio>
        <a-radio class="radio" :value="30"> 30s </a-radio>
        <a-radio class="radio" :value="60"> 1min </a-radio>
        <a-radio class="radio" :value="600"> 10min </a-radio>
        <a-radio class="radio" :value="1800"> 30min </a-radio>
        <a-radio class="radio" :value="3600"> 1h </a-radio>
        <a-radio class="radio" :value="0"> {{ $t("mouse.never") }} </a-radio>
      </a-radio-group>
      <md-field class="num">
        <md-input
          @change="sleepOneTimeBT = Number($event.target.value)"
          :value="sleepOneTimeBT"
          class="number-input"
          min="0"
          max="65535"
          step="1"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 65535 ? 65535 : this.value;
          this.value = this.value < 0 ? 0 : this.value;"
        ></md-input>
        <span class="md-suffix">s</span>
      </md-field>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.sleepOneTime24G") }}</div>
      <a-radio-group v-model="sleepOneTime24G" class="radio-group">
        <a-radio class="radio" :value="15"> 15s </a-radio>
        <a-radio class="radio" :value="30"> 30s </a-radio>
        <a-radio class="radio" :value="60"> 1min </a-radio>
        <a-radio class="radio" :value="600"> 10min </a-radio>
        <a-radio class="radio" :value="1800"> 30min </a-radio>
        <a-radio class="radio" :value="3600"> 1h </a-radio>
        <a-radio class="radio" :value="0"> {{ $t("mouse.never") }} </a-radio>
      </a-radio-group>
      <md-field class="num">
        <md-input
          @change="sleepOneTime24G = Number($event.target.value)"
          :value="sleepOneTime24G"
          class="number-input"
          min="0"
          max="65535"
          step="1"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 65535 ? 65535 : this.value;
          this.value = this.value < 0 ? 0 : this.value;"
        ></md-input>
        <span class="md-suffix">s</span>
      </md-field>
    </div>
    <div class="param-item">
      <div class="name">
        {{ $t("mouse.reportRate") }}
        <a-popover placement="right">
          <template slot="content">
            <div class="name-question">
              {{ $t("mouse.reportRateTip") }}
            </div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
      </div>
      <a-radio-group v-model="reportRate" class="radio-group">
        <a-radio class="radio" :value="125"> 125 </a-radio>
        <a-radio class="radio" :value="250"> 250 </a-radio>
        <a-radio class="radio" :value="500"> 500 </a-radio>
        <a-radio class="radio" :value="1000"> 1000 </a-radio>
        <a-radio class="radio" :value="2000"> 2000 </a-radio>
        <a-radio class="radio" :value="4000"> 4000 </a-radio>
        <a-radio class="radio" :value="8000"> 8000 </a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.liftCutOff") }}</div>
      <a-radio-group
        v-if="param.mouseID === 1935"
        v-model="liftCutOff"
        class="radio-group"
      >
        <a-radio class="radio" :value="0"> {{ $t("mouse.low") }} </a-radio>
        <a-radio class="radio" :value="1"> {{ $t("mouse.high") }} </a-radio>
      </a-radio-group>
      <a-radio-group v-else v-model="liftCutOff" class="radio-group">
        <a-radio class="radio" :value="0"> {{ $t("mouse.low") }} </a-radio>
        <a-radio class="radio" :value="1"> {{ $t("mouse.middle") }} </a-radio>
        <a-radio class="radio" :value="2"> {{ $t("mouse.high") }} </a-radio>
      </a-radio-group>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.motionSync") }}</div>
      <a-radio-group v-model="motionSync" class="radio-group">
        <a-radio class="radio" :value="1"> {{ $t("mouse.on") }} </a-radio>
        <a-radio class="radio" :value="0"> {{ $t("mouse.off") }} </a-radio>
      </a-radio-group>
    </div>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.angleSnap") }}</div>
      <md-switch class="md-primary" v-model="angleSnap"></md-switch>
    </div>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.rippleCorrection") }}</div>
      <md-switch class="md-primary" v-model="rippleCorrection"></md-switch>
    </div>
    <div class="button" @click="onSave" v-if="false">
      {{ $t("save") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseParam",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      profile: 0,
      keySensitivity: 1, //按键灵敏度 1~10
      USBDebounce: 6, // USB 去抖动 1~255
      twoPointFourGDebounce: 6, // 2.4G 去抖动 1~255
      BTDebounce: 6, // 蓝牙去抖动 1~255
      buttonChangeTime: 12, // 双击间隔时间 1~255
      wheelToButton: 1, // 滚轮模拟按键消抖 1~255
      buttonToWheel: 1, // 按键模拟滚轮消抖 1~255
      sleepOneTime24G: 30, // 2.4G一次休眠 0~65535
      sleepOneTimeBT: 600, // 蓝牙一次休眠 0~65535
      reportRate: 1000, // 鼠标回报率 125,250,500,1000,2000,4000,8000
      liftCutOff: 1, // 静默高度 低：0，高：1
      motionSync: 1, // 运动同步开关：开：1， 关：0
      angleSnap: false, // 直线修正 关：0， 开：1
      rippleCorrection: false, // 波纹修正 关：0， 开：4
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState("mouse", {
      param: "param",
    }),
  },
  methods: {
    onSave() {
      const param = {
        ...this.param,
        profile: this.profile,
        keySensitivity: this.keySensitivity,
        USBDebounce: [80, 63, 47, 31, 15, 7, 3][this.USBDebounce] || 3,
        twoPointFourGDebounce:
          [39, 31, 23, 15, 7, 3, 1][this.twoPointFourGDebounce] || 1,
        BTDebounce: [10, 8, 6, 4, 3, 2, 1][this.BTDebounce] || 1,
        buttonChangeTime: this.buttonChangeTime,
        wheelToButton: this.wheelToButton,
        buttonToWheel: this.buttonToWheel,
        sleepOneTime24G: this.sleepOneTime24G,
        sleepOneTimeBT: this.sleepOneTimeBT,
        reportRate: this.reportRate,
        liftCutOff: this.liftCutOff,
        motionSync: this.motionSync,
        angleSnap: this.angleSnap ? 1 : 0,
        rippleCorrection: this.rippleCorrection ? 4 : 0,
        mouseID: this.param.mouseID,
      };
      this.$store.dispatch("loader/setMouseInfo", param);
      this.$store.dispatch("mouse/setParam", param);
      // this.$message.info(this.$t("loader.saveSuccess"));
    },
  },
  mounted() {
    const data = this.param;
    this.profile = data.profile;
    this.keySensitivity = data.keySensitivity;
    this.USBDebounce = [80, 63, 47, 31, 15, 7, 3].findIndex(
      (i) => i === data.USBDebounce || i === 1
    );
    this.twoPointFourGDebounce = [39, 31, 23, 15, 7, 3, 1].findIndex(
      (i) => i === data.twoPointFourGDebounce || i === 1
    );
    this.BTDebounce = [10, 8, 6, 4, 3, 2, 1].findIndex(
      (i) => i === data.BTDebounce || i === 1
    );
    this.buttonChangeTime = data.buttonChangeTime;
    this.wheelToButton = data.wheelToButton;
    this.buttonToWheel = data.buttonToWheel;
    this.sleepOneTime24G = data.sleepOneTime24G;
    this.sleepOneTimeBT = data.sleepOneTimeBT;
    this.reportRate = data.reportRate;
    this.liftCutOff = data.liftCutOff;
    this.motionSync = data.motionSync;
    this.angleSnap = data.angleSnap > 0;
    this.rippleCorrection = data.rippleCorrection > 0;

    let timer = 0;
    this.$watch(
      "$data",
      function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(this.onSave, 200);
      },
      { deep: true }
    );
  },
};
</script>
<style lang="scss" scoped>
.param {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 1200px;
    text-align: left;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .param-item {
    @include flex-center;
    width: 1200px;
    justify-content: flex-start;
    padding: 15px 0;
    font-size: 20px;

    .name {
      @include flex-center;
      font-size: 20px;
      width: 200px;
      margin-right: 20px;
      justify-content: flex-start;

      .name-tip {
        color: $primary-color;
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .slider {
      width: 300px;
      margin-right: 40px;
      margin-left: 93px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
      }
    }

    .color {
      width: 25px;
      height: 25px;
      border: 1px solid $primary-color;
      margin-left: 30px;

      & + .num {
        margin-left: 10px;
      }
    }

    .num,
    .tip {
      width: 80px;
      font-size: 20px;
      margin: 0 40px 0 0;
      padding: 0;
      white-space: nowrap;

      .number-input {
        width: 100%;
        text-align: center;
      }
    }

    .tip {
      width: auto;
      font-size: 16px;
      color: #cccccc;
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }

  &.cn .param-item .slider {
    margin-left: 50px;
  }
}

.name-question {
  width: 290px;
  text-align: justify;
}
</style>

<style lang="scss">
.param {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-dot-active {
      border-color: transparent;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    background: #101010;
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .md-switch.md-theme-default.md-checked.md-primary .md-switch-container {
    background-color: rgb(0, 200, 0);
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
